import { ApplicationRef, ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { PieChartModule } from 'ChartApp/ts/features/pie-chart/pie-chart.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { SideMenuModule } from 'NewAngular/features/components/side-menu/side-menu.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { PieChartComponent } from 'ChartApp/ts/features/pie-chart/pie-chart.component';
import { EsgHoldingsTableComponent } from 'EsgApp/apps/esg-app/components/esg-holdings-table-component/esg-holdings-table.component';
import { EsgInfoPopoverComponent } from 'EsgApp/apps/esg-app/components/esg-info-popover-component/esg-info-popover.component';
import { EsgNewsComponent } from 'EsgApp/apps/esg-app/components/esg-news-component/esg-news.component';
import { EsgPosNegChartComponent } from 'EsgApp/apps/esg-app/components/esg-pos-neg-chart-component/esg-pos-neg-chart.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { getLogger } from 'NewAngular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AppModule {
    constructor(_document, componentFactoryResolver) {
        this._document = _document;
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ngDoBootstrap(applicationRef) {
        AppModule.bootstrapComponents.forEach((component) => {
            const { selector } = this.componentFactoryResolver.resolveComponentFactory(component);
            const elements = this._document.querySelectorAll(selector);
            elements.forEach((element) => {
                applicationRef.bootstrap(component, element);
            });
        });
    }
}
AppModule.bootstrapComponents = [
    EsgInfoPopoverComponent,
    EsgNewsComponent,
    EsgPosNegChartComponent,
    EsgHoldingsTableComponent,
    PieChartComponent,
    SideMenuComponent,
    SecurityHeaderControlComponent,
    TopBarNavComponent,
];
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ConfigModule,
        BrowserModule,
        IconModule,
        ModuleUpsellModule,
        NavigationModule,
        PieChartModule,
        SideMenuModule,
        SecurityHeaderControlModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
        TooltipModule] });
